import { useEffect, useRef, useState } from 'react';

export const useMeasureOverflow = <T extends HTMLElement>() => {
  const measureRef = useRef<T>(null);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const [isMeasured, setIsMeasured] = useState(false);

  useEffect(() => {
    const timeoutId = window.setTimeout(() => {
      if (measureRef.current && !isMeasured) {
        const { scrollHeight, clientHeight } = measureRef.current;

        setIsOverflowing(scrollHeight > clientHeight);
        setIsMeasured(true);
      }
    });

    return () => {
      window.clearTimeout(timeoutId);
    };
  }, [isMeasured]);

  return { measureRef, isOverflowing, isMeasured };
};
